export default class ReleaseType {
    constructor(
        public id = '',
        public name = '',
        public description = '',
    ) {}
}